import { DRAGGABLE_TYPES, WITH_APP_PAGE_BODY_SIZES_CLASS_NAME } from "Common/componentUtils/constants";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import classNames from "classnames";
import React, { useMemo } from "react";
import Graph from "../graph";
import Map from "../map";
import Table from "../table";
import ActionPanel from "./actionPanel";
import ContentSwitcher from "./contentSwitcher";
import ReadOnlyIndication from "./readOnlyIndication";
const droppableTypes = [DRAGGABLE_TYPES.DOCUMENT_OBJECT];
const documentTypeRender = {
    [DOCUMENT_TYPE.GRAPH]: (React.createElement(Graph, { className: "h-auto", droppableTypes: droppableTypes, rowActionsPanelHeight: 50, bottomOffset: 0 })),
    [DOCUMENT_TYPE.TABLE]: React.createElement(Table, { rowActionsPanelHeight: 50 }),
    [DOCUMENT_TYPE.MAP]: React.createElement(Map, { rowActionsPanelHeight: 50 }),
    [DOCUMENT_TYPE.CONTENT]: React.createElement(ContentSwitcher, { rowActionsPanelHeight: 50, bottomOffset: 0 })
};
const handlePreventDefault = (evt) => {
    evt.preventDefault();
};
export default function DocumentDetails(props) {
    const DocumentComponent = props.documentType && documentTypeRender[props.documentType];
    const right = useMemo(() => (props.calculatedDetailedPanelOpen ? props.rightSidePanelWidth || 0 : 0), [props.calculatedDetailedPanelOpen, props.rightSidePanelWidth]);
    const shouldShowActionPanel = props.documentType === DOCUMENT_TYPE.CONTENT || props.documentType === DOCUMENT_TYPE.TABLE;
    return (React.createElement("div", { className: "stretched-to-fit" },
        React.createElement("div", { className: classNames("grid-rows-auto-1fr position-relative", WITH_APP_PAGE_BODY_SIZES_CLASS_NAME), onContextMenu: handlePreventDefault },
            React.createElement("div", { className: "bg-light-surface overflow-hidden" }, shouldShowActionPanel && React.createElement(ActionPanel, null)), DocumentComponent !== null && DocumentComponent !== void 0 ? DocumentComponent : React.createElement("div", null),
            React.createElement(ReadOnlyIndication, { top: 0, right: 0, left: 0, temporaryRight: right, bottom: 0 }))));
}
